import * as React from 'react';
import { Avatar, Heading, Link, Text } from '@/hen-ui/atomics';
import { Flex } from '@/hen-ui/composites/Flex';

export interface ExpertByLineProps {
  name: string;
  role: string;
  avatarSrc?: string;
  avatarFallback?: string;
  href?: string;
}

export function ExpertByLine({
  name,
  role,
  avatarSrc,
  avatarFallback,
  href,
}: ExpertByLineProps) {
  return (
    <Flex direction='row' align='center' gap='sm' className='text-left'>
      <Avatar
        src={avatarSrc}
        fallback={avatarFallback}
        alt={`Photo of ${name}`}
        size='lg'
      />
      <Flex direction='column' justify='center' gap='none' className='min-w-0'>
        <Heading variant='h6' color='primary' asChild={!!href}>
          {href ? (
            <Link href={href} underline='none'>
              {name}
            </Link>
          ) : (
            name
          )}
        </Heading>
        <Text variant='l1' color='default'>
          {role}
        </Text>
      </Flex>
    </Flex>
  );
}
